import * as TechValueCodes from "./TechValueCodes";
import { toMapFn } from "~/utils/reducers";
import { type TechFilterDefinition } from "~/GearboxSelectionAssistant/models";

export * as TechValueCodes from "./TechValueCodes";
export const TECH_VALUE_CODE_LIST = Object.values(TechValueCodes);

export const getInitialDimensionValues = (definitions: Record<string, TechFilterDefinition>) => {
  return toMapFn(
    TECH_VALUE_CODE_LIST.map((key) => definitions[key]).filter(Boolean),
    (def) => def.code,
    (def) => [def.min, def.max] as [number, number]
  );
};
